import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntermediateMaterialIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	className: "MuiSvgIcon-root",
	focusable: "false",
	"aria-hidden": "true",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.530076711479726 0.9632487980260684)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.4810096,-7.54951657e-14 L13.2634369,2.43920029 L16.9481939,2.10131556 L17.7568363,5.72873853 L20.9367564,7.62415623 L19.4731245,11.028489 L20.931545,14.4359381 L17.7488097,16.3353844 L16.9318962,19.9498487 L13.2451882,19.6141637 L10.4619272,22.0639918 L7.67949983,19.6247915 L3.99165269,19.9721868 L3.17992009,16.3542744 L-7.06990022e-13,14.4588567 L1.46672209,11.0450134 L0.00830160927,7.63756426 L3.19412709,5.72860748 L4.01413076,2.1046326 L7.69774855,2.44982817 L10.4810096,-7.54951657e-14 Z M10.9479233,6.2367512 L9.65992329,6.2367512 C9.61325662,6.2367512 9.57358996,6.25308454 9.54092329,6.2857512 C9.50825662,6.31841787 9.49192329,6.35808454 9.49192329,6.4047512 L9.49192329,15.8687512 C9.49192329,15.9154179 9.50825662,15.9550845 9.54092329,15.9877512 C9.57358996,16.0204179 9.61325662,16.0367512 9.65992329,16.0367512 L10.9479233,16.0367512 C10.99459,16.0367512 11.0342566,16.0204179 11.0669233,15.9877512 C11.09959,15.9550845 11.1159233,15.9154179 11.1159233,15.8687512 L11.1159233,6.4047512 C11.1159233,6.35808454 11.09959,6.31841787 11.0669233,6.2857512 C11.0342566,6.25308454 10.99459,6.2367512 10.9479233,6.2367512 Z",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(-1.530076711480433 -0.963248798026143)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
					children: /* @__PURE__ */ _jsx("polygon", {
						points: "1.53007671,0.963248798 22.4668331,0.963248798 22.4668331,23.0272406 1.53007671,23.0272406 1.53007671,0.963248798",
						stroke: "none",
						fill: "#282828"
					})
				})
			})
		})
	})
});
export default SvgIntermediateMaterialIcon;
